import React from 'react';
import Victual from '../../Victual/Victual';

export default () => {
  return (
    <div className='list'>
      <h2 id='nigiri'>Nigiri</h2>
      <Victual name='Ama-Egi' 
      desc='Shrimp placed on a bar of rice'
      price='1.25'/>
      <Victual name='Engawa' 
      desc='Lorum Ipsum'
      price='1.00'/>
      <Victual name='Surimi' 
      desc='Lorum Ipsum'
      price='6.25'/>
      <Victual name='Tofubag' 
      desc='Lorum Ipsum'
      price='4.25'/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Nigiri/Nigiri.js